export default __webpack_public_path__ + "static/media/e-bannergr.af6588d9.jpg";